export const STYLE_DISCOVERY_PROVIDERS = {
  pinterest: {
    id: 'pinterest',
    kind: 'style_reference',
    markets: ['KR', 'GLOBAL'],
  },
  musinsa: {
    id: 'musinsa',
    kind: 'commerce_search',
    markets: ['KR'],
  },
};

export const STYLE_DISCOVERY_SEARCH_URLS = {
  pinterest: {
    baseUrl: 'https://www.pinterest.com/search/pins/',
    queryParam: 'q',
  },
  musinsa: {
    baseUrl: 'https://www.musinsa.com/search/goods',
    queryParam: 'keyword',
  },
};

export function getVisibleProviderIds({ market, marketResolved }) {
  const providerIds = ['pinterest'];
  if (marketResolved && market === 'KR') providerIds.push('musinsa');
  return providerIds;
}
